



















import {Component, Prop, Vue} from "vue-property-decorator";
import Number from "@/components/inputs/Number.vue";
import Id from "@/components/inputs/Id.vue";

@Component({
    components: {Id, Number}
})
export default class VariantSelector extends Vue {
    @Prop({}) value!:any;
    @Prop({}) variantOptions!:any[];
    @Prop({}) product_id!:number;
    @Prop({default:"12"}) md!:string;
    @Prop({}) label!:string;
    items:any[] = [];
    dialog:boolean = false;
    async updateValue (value:string) {
        this.$emit('input', this.variantOptions);
    }
    success(){
        this.dialog = false;
    }
    async add(){
        try{

        }catch (e) {
            alert(e.message);
        }
    }

}
